export default "__VITE_ASSET__DUy$RorA__"